import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import BluelabProbeCareKitConductivity from "../../Assets/Bluelab Probe Care Kit - Conductivity.webp";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Bluelab_Probe_Care_Kit_Conductivity = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 43,
      name: "Bluelab Probe Care Kit - Conductivity",
      price: 1344,
      image: BluelabProbeCareKitConductivity,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={BluelabProbeCareKitConductivity}
                  alt="Product 1"
                  className="d-block w-100"
                />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">
              Bluelab Probe Care Kit - Conductivity
            </h2>
            <p className="product-price">₹{1344}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3 text-justify">
              <h5>
                Your Essential Kit for Cleaning and Maintaining Conductivity
                Probes
              </h5>
              The Bluelab Probe Care Kit – Conductivity includes everything you
              need to ensure your conductivity probes remain in top condition:
              <ul className="mt-3">
                <li>Probe Care Instructions for easy maintenance guidance</li>
                <li>
                  Two 18 ml single-use sachets of Bluelab 2.77 EC Conductivity
                  Standard Solution
                </li>
                <li>One Plastic Cup for convenient usage</li>
                <li>
                  Bluelab Conductivity Probe Cleaner for effective cleaning
                </li>
                <li>
                  Chamois Cloth for gentle cleaning of your conductivity probe
                </li>
                <li>
                  <i>*Note: Packaging may vary.</i>
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Bluelab_Probe_Care_Kit_Conductivity;
